"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatingExtractWaitingDialog = void 0;
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var JumpstartTelemetry_1 = require("../../telemetry/JumpstartTelemetry");
var LearnMoreLink_1 = require("../learn_more_link/LearnMoreLink");
var WaitingDialog_1 = require("./WaitingDialog");
var CreatingExtractWaitingDialog = /** @class */ (function (_super) {
    __extends(CreatingExtractWaitingDialog, _super);
    function CreatingExtractWaitingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.wrappedOnCloseRequest = function (openDurationMs) {
            _this.jumpstartTelemetry.ExtractWaiting.Dismiss(openDurationMs);
            _this.props.onCloseRequest();
        };
        _this.onLearnMoreLinkClick = function () {
            _this.jumpstartTelemetry.ExtractWaiting.LearnMore.Click();
        };
        _this.jumpstartTelemetry = new JumpstartTelemetry_1.JumpstartTelemetry(props.sendEventFn);
        return _this;
    }
    CreatingExtractWaitingDialog.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.sendEventFn !== prevProps.sendEventFn) {
            this.jumpstartTelemetry = new JumpstartTelemetry_1.JumpstartTelemetry(this.props.sendEventFn);
        }
    };
    CreatingExtractWaitingDialog.prototype.componentDidMount = function () {
        this.jumpstartTelemetry.ExtractWaiting.Open();
    };
    CreatingExtractWaitingDialog.prototype.createMessage = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, Localize_1.Messages.CreatingExtractDialogMessage()),
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.CreateExtractWaitingDialog },
                Localize_1.Messages.CreatingExtractDialogSensitiveDataMessage(),
                this.props.helpUrl && (React.createElement(LearnMoreLink_1.LearnMoreLink, { notifyOnClick: this.onLearnMoreLinkClick, testId: 'starter-extract-waiting-help-link', text: Localize_1.Messages.CreatingExtractDialogSensitiveDataLink(), helpUrl: this.props.helpUrl })))));
    };
    CreatingExtractWaitingDialog.prototype.render = function () {
        var dialogProps = {
            onCloseRequest: this.wrappedOnCloseRequest,
            showFooterButton: true,
            title: Localize_1.Messages.CreatingExtractDialogTitle(),
            message: this.createMessage(),
            testId: 'CreatingExtractWaitingDialog',
        };
        return React.createElement(WaitingDialog_1.WaitingDialog, __assign({}, dialogProps));
    };
    return CreatingExtractWaitingDialog;
}(React.Component));
exports.CreatingExtractWaitingDialog = CreatingExtractWaitingDialog;
//# sourceMappingURL=CreatingExtractWaitingDialog.js.map